import Swiper, { Navigation, Pagination, Lazy} from 'swiper'

export default function() {
	Swiper.use([Navigation, Pagination, Lazy])
	let container = document.querySelector('.section-5__slider')
	new Swiper(container.querySelector('.swiper-container'), {
		// Optional parameters
		loop: true,
		slidesPerView: 2,
		spaceBetween: 32,
		preloadImages: false,
		lazy: {
			loadPrevNext: false,
		},
		pagination: {
			el: container.querySelector('.swiper-pagination'),
			clickable: true,
		},
		// Navigation arrows
		navigation: {
			nextEl: container.querySelector('.swiper-button-next'),
			prevEl: container.querySelector('.swiper-button-prev'),
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			600: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			},
		}
	})
}